var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "before-close": _vm.goodsSelDialogClose,
            visible: _vm.dialogVisible,
            title: "选择商品",
            "custom-class": "bairun-dialog bairun-dialog-small"
          }
        },
        [
          _c(
            "el-row",
            {
              staticStyle: { "margin-bottom": "15px", "text-align": "center" }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-input",
                    {
                      staticClass: "bairun-input-small",
                      staticStyle: { width: "60%", "text-align": "center" },
                      attrs: {
                        placeholder: "商品详情名称/spu编号",
                        clearable: ""
                      },
                      on: {
                        input: function($event) {
                          return _vm.inputChange($event)
                        }
                      },
                      model: {
                        value: _vm.searchText,
                        callback: function($$v) {
                          _vm.searchText = $$v
                        },
                        expression: "searchText"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onSearch },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "bairun-dialog-table bairun-table-pager" },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    stripe: "",
                    "tooltip-effect": "dark"
                  },
                  on: { "selection-change": _vm.handleSelChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "ID", width: "40", type: "selection" }
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "默认spu图标",
                      width: "100",
                      align: "right"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("el-image", {
                              attrs: {
                                src: scope.row.imgUrl,
                                fit: "contain",
                                "preview-src-list": [scope.row.imgUrl]
                              }
                            })
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "商品详情名称", width: "400" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("div", { staticClass: "table-goods-info" }, [
                              _c(
                                "div",
                                { staticClass: "bairun-table-goods-name" },
                                [_vm._v(_vm._s(scope.row.goodsDetailTitle))]
                              ),
                              _c(
                                "div",
                                [
                                  scope.row.isHot == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [_vm._v("热卖")]
                                      )
                                    : _vm._e(),
                                  _vm._v("   "),
                                  scope.row.isRecommend == 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "primary",
                                            size: "mini",
                                            effect: "plain"
                                          }
                                        },
                                        [_vm._v("推荐")]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]),
                            _c("div", { staticClass: "bairun-rotate-tag" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("getActivityTypes")(
                                      scope.row.activityTypes
                                    )
                                  )
                                )
                              ])
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "二级类目", prop: "categoryName" }
                  }),
                  _c("el-table-column", {
                    attrs: { label: "提货方式", prop: "logisticsTypes" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.logisticsTypes == "1"
                              ? _c("span", [_vm._v("门店自提")])
                              : _vm._e(),
                            scope.row.logisticsTypes == "2"
                              ? _c("span", [_vm._v("包邮")])
                              : _vm._e(),
                            scope.row.logisticsTypes == "1,2"
                              ? _c("span", [_vm._v("包邮或门店自提")])
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", prop: "showStatus" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            scope.row.showStatus == 1
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [_vm._v("已上架")]
                                )
                              : _vm._e(),
                            scope.row.showStatus == 2
                              ? _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: "danger",
                                      size: "mini",
                                      effect: "plain"
                                    }
                                  },
                                  [_vm._v("已下架")]
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("el-pagination", {
                style: { float: "right", padding: "20px" },
                attrs: {
                  "current-page": _vm.page,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  layout: "total, prev, pager, next, jumper"
                },
                on: { "current-change": _vm.handleCurrentChange }
              })
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.goodsSelDialogClose } }, [
                _vm._v("取 消")
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.goodsSelDialogOk }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }